import React from "react";
import HighLevelGigCardListPage from "./HighLevelGigCardListPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface HighLevelGigCardListPageContainerProps extends RouteProps, withValidUserRoleProps {}

const HighLevelGigCardListPageContainer = (props: HighLevelGigCardListPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <HighLevelGigCardListPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(HighLevelGigCardListPageContainer);
